import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CustomersService } from 'src/app/services/core/services/customers/customers.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { QuickbooksService } from 'src/app/services/core/services/quickbooks/quickbooks.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
@UntilDestroy()
@Component({
  selector: 'app-quickbooks-list',
  templateUrl: './quickbooks-list.component.html',
  styleUrls: ['./quickbooks-list.component.css']
})
export class QuickbooksListComponent implements OnInit {
  companies: any
    preCompanies:any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any;
  dataList: any;

  constructor(
    private credentialService: CredentialService,
    private companyService: CompanyService,
    private quickbooksService: QuickbooksService,
  ) { }


  ngOnInit(): void {
   this.getCompanies();
    this.getAll(this.currentPage);
  }

   getCompanies() {
    const queryparams = {
      limit: 9999
    }
    this.credentialService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.companies = data.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  getAll(page: any) {
    let queryParams = {
      limit: 50,
      page,
    }
    this.quickbooksService.getAll(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
          this.dataList = data.results
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAll(page);
  }

}